export var FILTER_TYPES = {
  DEFAULT: 'DEFAULT_FILTER',
  MISSIONS: 'MISSIONS_FILTER'
};